import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/detect/ADetectArticleSuggest/index", {
        params: {
            ...params
        }
    } )
}
function ADD_DATA(params) {
    return  axios.get("/detect/ADetectArticleSuggest/add",{
        params: {}
    } )
}
function EDIT_DATA(params) {
    return  axios.post("/detect/ADetectArticleSuggest/edit", {id:params})
}
function SUBMIT_ADD(params) {
    return  axios.post("/detect/ADetectArticleSuggest/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/detect/ADetectArticleSuggest/editPost",{...params} )
}


function CHANG_STATUS (params) {
    return  axios.post("/detect/ADetectArticleSuggest/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.get("/detect/ADetectArticleSuggest/delete",{
        params: {
            ids:params
        }
    } )
}

export default {
    GET_LIST,
    ADD_DATA,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
}